/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompanyBillingInfoResource
 */
export interface ClientCompanyBillingInfoResource {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInfoResource
     */
    billingContact?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientCompanyBillingInfoResource
     */
    otherBillingContacts?: Array<string>;
}

/**
 * Check if a given object implements the ClientCompanyBillingInfoResource interface.
 */
export function instanceOfClientCompanyBillingInfoResource(value: object): value is ClientCompanyBillingInfoResource {
    return true;
}

export function ClientCompanyBillingInfoResourceFromJSON(json: any): ClientCompanyBillingInfoResource {
    return ClientCompanyBillingInfoResourceFromJSONTyped(json, false);
}

export function ClientCompanyBillingInfoResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyBillingInfoResource {
    if (json == null) {
        return json;
    }
    return {
        
        'billingContact': json['billingContact'] == null ? undefined : json['billingContact'],
        'otherBillingContacts': json['otherBillingContacts'] == null ? undefined : json['otherBillingContacts'],
    };
}

export function ClientCompanyBillingInfoResourceToJSON(value?: ClientCompanyBillingInfoResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'billingContact': value['billingContact'],
        'otherBillingContacts': value['otherBillingContacts'],
    };
}

